<template>
  <div class="flex flex-col gap-y-3 overflow-y-auto pr-2">
    <ul class="flex gap-x-3 items-center">
      <strong>{{ state.model?.number }}</strong>
      <text class="text-gray-400 text-xs">无采购付款</text>
      <c_money
        :key="state.model.amount"
        :value="state.model.amount"
        :size="20"
        bold
        :prefix="false"
      />
    </ul>
    <c_cell title="供应商">
      <template #default>
        <div class="flex gap-x-3">
          <text>{{ state.model?.supplier?.name }}</text>
          <li class="flex gap-x-3 text-xs text-gray-400">
            <text>{{ state.model?.supplier?.number }}</text>
            <text>{{ state.model?.supplier?.contact_name }}</text>
            <c_sex
              :value="
                state.model?.supplier?.contact_title == '先生' ? '男' : '女'
              "
            />
            <text>{{
              $phoneFormat(state.model?.supplier?.contact_phone)
            }}</text>
          </li>
        </div>
      </template>
    </c_cell>
    <ul class="flex gap-x-5">
      <c_cell title="付款方式" :value="state.model?.d_payment_type_name" />
      <c_cell title="收款信息">
        <template #default>
          <div class="flex gap-x-2">
            <text>{{ state.model?.supplier_bank_account?.opening_bank }}</text>
            <text class="text-gray-400">{{
              state.model?.supplier_bank_account?.name
            }}</text>
            <text class="text-gray-400">{{
              state.model?.supplier_bank_account?.account
            }}</text>
          </div>
        </template>
      </c_cell>
    </ul>
    <c_cell title="申请说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <div
          class="flex flex-wrap gap-x-5 gap-y-2"
          v-if="state.model?.attachment?.length > 0"
        >
          <text
            v-for="file in state.model?.attachment"
            :key="item"
            class="hover:underline cursor-pointer text-green-700"
            @click="$openFile(file.file_url)"
          >
            {{ file.filename }}
          </text>
        </div>
        <text v-else>-</text>
      </template>
    </c_cell>
    <template v-if="state.model.status === 0">
      <div
        class="border-t border-green-800 border-dashed mt-2 text-center flex justify-center"
      >
        <li
          class="text-green-800 font-bold bg-white px-5"
          style="margin-top: -10px; width: fit-content"
        >
          审批
        </li>
      </div>
      <el-input
        v-model="state.remark"
        type="textarea"
        :autosize="{ minRows: 3 }"
        placeholder="说明"
        class="round"
      />
      <div class="flex items-center justify-center">
        <el-button type="danger" @click="onSubmit(2)" size="large"
          >不通过</el-button
        >
        <el-button
          type="primary"
          @click="onSubmit(1)"
          size="large"
          class="!w-32"
          >通过</el-button
        >
      </div>
    </template>
    <strong>审核进度</strong>
    <el-steps :active="state.model.step" align-center>
      <el-step
        v-for="item in state.flowApproveStepList"
        :key="item"
        :title="item.step_name"
        :description="state.model.create_time"
      >
        <template #title>
          <div class="flex items-center gap-x-1 justify-center">
            <strong>{{ item.step_name }}</strong>
            <c_status arrName="Common_Check_Status" :value="item.status" />
          </div>
        </template>
        <template #description>
          <div class="flex flex-col items-center">
            <ul class="flex gap-x-1">
              <text>{{ item?.approve_admin_name }}</text>
              <text class="text-gray-400">{{
                item?.approve_department_name
              }}</text>
              <text>{{ item.approve_time }}</text>
            </ul>
            <ul v-if="item?.log?.msg" class="text-xs">
              <text class="text-gray-400">备注：</text>
              <text class="text-gray-500">{{ item?.log?.msg }}</text>
            </ul>
          </div>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  supplierpaymentapply_search,
  supplierpaymentapply_approve,
} from "@/http/fukuanshenpi";
import { ElMessage, ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      model: {},
      list_data: [],
    });
    onMounted(() => {
      if (props.id) {
        supplierpaymentapply_search(props.id).then((res) => {
          if (res.status == 200) {
            const { info, meetingPurchaseList, flowApproveStepList } =
              res.data?.data || {};
            state.model = info;
            state.list_data = meetingPurchaseList;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    });
    const onSubmit = (pass) => {
      if (pass == 2 && !state.remark) {
        ElMessage.warning("请输入审批说明！");
        return false;
      }

      ElMessageBox.confirm(
        `您确定<strong style="color: ${pass == 1 ? "#080" : "#f00"};">${
          pass == 1 ? "同意" : "拒绝"
        }</strong>该付款申请吗？`,
        "付款审批",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        supplierpaymentapply_approve({
          id: [props.id],
          status: pass,
          msg: state.remark,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };
    return { state, onSubmit };
  },
};
</script>
<style scoped></style>
